import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getModuleGroups } from '../../utilities/api';

export const fetchModuleGroup = createAsyncThunk('moduleGroup/fetch', async (_, { rejectWithValue }) => {
    try {
        const data = await getModuleGroups();
        return data;
    } catch (error) {
        return rejectWithValue(error.message || 'Failed to fetch module groups');
    }
});

const initialState = {
    moduleGroupData: [],
    loading: false,
    error: null
};

const modulegroupSlice = createSlice({
    name: 'moduleGroup',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleGroup.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchModuleGroup.fulfilled, (state, action) => {
                state.loading = false;
                const raw = action.payload;
                const data = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
                state.moduleGroupData = data.map((g) => ({
                    ...g,
                    status: g.status || g.module_group_status || 'Active'
                }));
            })
            .addCase(fetchModuleGroup.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.moduleGroupData = [];
            });
    }
});

export const { clearError } = modulegroupSlice.actions;

export const selectModuleGroupData = (state) => state.moduleGroup.moduleGroupData;
export const selectLoading = (state) => state.moduleGroup.loading;
export const selectError = (state) => state.moduleGroup.error;

export default modulegroupSlice.reducer;
